import {Button, Card, CardBody, CardFooter, CardHeader, Checkbox, Input, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Validator from "../helper/validator/Validator";
import {ValidatorProvider} from "../helper/validator/ValidatorContext";
import {Toaster} from "../helper/Toaster";
import {registerService} from "../services/user/register";
import {toast} from "react-toastify";
import OtpField from "../components/system/otpField";
import PasswordField from "../components/system/passwordField";
import {checkAll} from "../helper/validator/Check";

const Register = () => {
  const backgroundPhoto = '/assets/login-background.jpeg';
  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('userInfo')) {
      if (localStorage.getItem('expiration')) {
        if (localStorage.getItem('token')) {
          window.location.href = "/";
        }
      }
    }
  }, []);

  // const validatorRef = useRef(null);
  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      Toaster.failure(null, <Typography variant={"small"}>
        رمز ورود با تکرار رمز عبور برابر نیست
      </Typography>);
      return
    }
    const res = checkAll();
    if (!res) {
      Toaster.failure(null, <Typography variant={"small"}>
        مقادیر الزامی را بر اساس راهنما تکمیل کنید
      </Typography>);
      return
    }
    const data = {
      name: name,
      family: family,
      phone: phone,
      password: password,
      code: confirmationCode
    };

    let result;

    result = await registerService(data)

    if (result.status === 201) {
      toast.success("ثبت نام با موفقیت انجام شد", {
        position: "top-right",
        closeOnClick: true
      });
      window.location.href = '/login'
    } else {
      Toaster.failure(null, <Typography variant={"small"}>
        کد تایید اشتباه است
      </Typography>);
    }

  };

  return (
    <ValidatorProvider>
      <div className={"flex justify-center items-center h-screen"} style={{backgroundImage: `url(${backgroundPhoto})`}}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <Card className="flex w-full mx-4 md:w-2/3">
          <CardHeader variant="gradient" color="gray" className="mb-4 pt-4 grid place-items-center">
            <Typography variant="h3" color="white" className="pt-4 mb-4">
              ثبت نام
            </Typography>
          </CardHeader>
          <CardBody className="flex flex-col gap-4 py-8 px-4">
            <Input variant="standard" label="* نام" size="lg" value={name} onChange={(e) => setName(e.target.value)}/>
            <Validator state={name} rules="required|alphabetic"/>
            <Input variant="standard" label="نام خانوادگی" size="lg" value={family}
                   onChange={(e) => setFamily(e.target.value)}/>
            <Validator state={family} rules="required|alphabetic"/>
            <Input variant="standard" label="شماره همراه" size="lg" value={phone}
                   onChange={(e) => setPhone(e.target.value)}/>
            <Validator state={phone} rules="required|phoneNumber|len=11"/>
            <PasswordField label="رمز ورود" size="lg" onChange={setPassword}/>
            <Validator state={password} rules="required|password"/>
            <PasswordField label="تکرار رمز ورود" size="lg" onChange={setConfirmPassword}/>
            <Validator state={confirmPassword} rules={`required|matches=${password}`}/>
            <OtpField time={300} onChange={setConfirmationCode} userPhone={phone} setCodeSent={setCodeSent}/>
            <Validator state={confirmationCode} rules={`required`}/>
            <div className="flex flex-row -ml-2.5">
              <Checkbox className="flex-col -mt-2"/>
              <Typography className="flex-col">
                <a className="underline" href="https://mymobasher.com/terms/">شرایط و قوانین سایت</a> را
                خوانده و می‌پذیرم
              </Typography>
            </div>
          </CardBody>
          <CardFooter className="pt-0">
            <Button variant="gradient" fullWidth className="mb-4" onClick={handleSubmit}>
              ثبت نام
            </Button>
            <Typography variant="small" className="mt-6 flex justify-center">
              قبلا ثبت‌نام کردی؟ <a href="/login" className="mx-2 font-bold">ورود</a>
            </Typography>
          </CardFooter>
        </Card>
        {/*<Validator ref={validatorRef} />*/}
      </div>
    </ValidatorProvider>
  );
};

export default Register;
